import { render } from "./main.html?vue&type=template&id=22cca203&scoped=true&ts=true&external"
import script from "./main.ts?vue&type=script&lang=ts&external"
export * from "./main.ts?vue&type=script&lang=ts&external"

import "./main.scss?vue&type=style&index=0&id=22cca203&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cca203"]])

export default __exports__